import React, { useState } from 'react'
import '../UserCard/styles.scss'
import './styles.scss'
import { MultiAvatar } from 'components/common'
import { getNamesCardInChat } from 'utils/usersHelpers'
import { lang } from 'utils/helpers'

const CardInfoUserChannel = ({
  user,
  inInfo,
  classNameAvatar,
  isRemoved,
  handleRemoveModal,
  className,
  sizeAvatar = 32,
  buttonsActions
}) => {
  const [viewButton, setViewButton] = useState(false)

  const handleViewButton = (value) => {
    setViewButton(value)
  }

  return (
    <div
      className={`inchat-user-card__container ${inInfo ? 'inchat-user-info__info' : 'inchat-user-info__members'}
      ${className ? className : ''}
      `}
      onMouseOver={() => handleViewButton(true)}
      onMouseLeave={() => handleViewButton(false)}
      style={{
        backgroundColor: 'trasnparent',
        boxShadow: '0 0 0 0',
      }}
    >
      <div className={`inchat-user-card__container--avatar-text ${!inInfo ? 'inchat-user-info__members--avatar-container' : ''}`} >
        <MultiAvatar
          mainWidth={sizeAvatar}
          users={[user]}
          className={classNameAvatar}
        />
        <div
          className={`inchat-user-card-text ${!inInfo ? 'inchat-user-info__members--text-container' : ''}`}
        >
          <p className={`inchat-user-card-text__text inchat-user-card-text__text--title  ${!inInfo ? 'inchat-user-info__members--name' : ''}`} >{getNamesCardInChat([user])}</p>
        </div>
      </div>
      <div className='inchat-user-card__container--mnemonic'>
        { !inInfo && viewButton && !isRemoved && buttonsActions &&
          <button
            onClick={() => handleRemoveModal(user._id)}
            className='inchat-user-info__members--button'
          >{lang('dashboard_remove')}</button>
        }
      </div>
    </div>
  )
}

export default CardInfoUserChannel